import { Dialog } from 'primereact/dialog';

const GanadasPerdidasDialog = ({ visible, onHide }) => {
    return (
        <Dialog 
            header="Cotizaciones Ganadas vs Perdidas (Últimos 30 días)" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Ganadas</div>
                        <div className="text-4xl text-green-500 font-bold">1.000.000</div>
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Perdidas</div>
                        <div className="text-4xl text-red-500 font-bold">1.000.000</div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default GanadasPerdidasDialog;